import { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import BottomNav from '../components/BottomNav';
import ProductList from '../components/ProductList';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function Home() {
  const [products, setProducts] = useState([]);
  const [usernamePi, setUsernamePi] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    getProducts();

    const cachedUsername = localStorage.getItem('usernamePi');
    const cachedToken = localStorage.getItem('token');
    if (cachedUsername && cachedToken) {
      setUsernamePi(cachedUsername);
      axios.defaults.headers.common['Authorization'] = `Bearer ${cachedToken}`;
    }

    window.loginPiSDK = loginPiSDK; // 💡 bisa dipanggil dari PropertyDetail atau console
  }, []);

  const getProducts = (keyword = '') => {
    axios
      .get(`https://prodmejatika.bljambi.com/api/produk-publik?search=${keyword}`)
      .then((res) => {
        const produk = Array.isArray(res.data?.data?.data)
          ? res.data.data.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];

        console.log('✅ Produk dari API:', produk);
        setProducts(produk);
      })
      .catch((err) => {
        console.error('❌ Gagal ambil produk:', err);
        setProducts([]);
      });
  };

  const loginPiSDK = async () => {
    console.log('🟢 Login Pi SDK dimulai');

    if (!window?.Pi || typeof window.Pi.authenticate !== 'function') {
      Swal.fire({
        icon: 'warning',
        title: 'Pi Browser Diperlukan',
        text: 'Fitur ini hanya tersedia di dalam Pi Browser.',
      });
      return;
    }

    setIsLoggingIn(true);

    try {
      const scopes = ['username', 'payments', 'wallet_address'];
      const auth = await window.Pi.authenticate(scopes, function (incomplete) {
        console.log('🕓 Incomplete Payment:', incomplete);
      //  if (incomplete) {
          // Swal.fire({
          //  icon: 'info',
         //   title: 'Transaksi Tertunda',
         //   text: 'Ada transaksi sebelumnya yang belum selesai.',
         // });
       // }
      });

      const { accessToken, user } = auth;

      if (!user?.username || !accessToken) {
        Swal.fire({
          icon: 'error',
          title: 'Login Gagal',
          text: 'Username atau token tidak tersedia.',
        });
        setIsLoggingIn(false);
        return;
      }

      const payload = {
        accessToken,
        user_uid: user.uid,
        username: user.username,
      };

      const res = await axios.post('https://prodmejatika.bljambi.com/api/auth/sdk-login', payload);

      if (!res.data?.token) {
        throw new Error('Token backend tidak ditemukan.');
      }

      localStorage.setItem('usernamePi', user.username);
      localStorage.setItem('token', res.data.token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
      setUsernamePi(user.username);

      console.log('🧾 Token Pi SDK:', accessToken);
      console.log('🔐 Token Backend:', res.data.token);

      Swal.fire({
        icon: 'success',
        title: 'Login Berhasil!',
      
      });
    } catch (err) {
      console.error('❌ Login error:', err);
      Swal.fire({
        icon: 'error',
        title: 'Login Gagal',
        text: err?.message || 'Terjadi kesalahan saat login.',
      });
    } finally {
      setIsLoggingIn(false);
    }
  };

  const logoutPiUser = () => {
    localStorage.removeItem('usernamePi');
    localStorage.removeItem('token');
    setUsernamePi('');
    delete axios.defaults.headers.common['Authorization'];
    Swal.fire({
      icon: 'success',
      title: 'Logout Berhasil!',
      text: 'Terima kasih telah menggunakan aplikasi.',
    });
  };

  return (
    <Layout setProducts={setProducts}>
      <div className="mt-4">
        <div className="mb-4 text-sm text-gray-700">
          {usernamePi ? (
            <div className="flex justify-between items-center">
              <span>👤 Login sebagai <b>{usernamePi}</b></span>
              <button
                onClick={logoutPiUser}
                className="px-3 py-1 bg-red-600 text-white rounded text-xs"
              >
                🚪 Logout
              </button>
            </div>
          ) : (
            <button
              onClick={loginPiSDK}
              disabled={isLoggingIn}
              className="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded"
            >
              {isLoggingIn ? 'Memproses...' : '🔐 Login via Pi'}
            </button>
          )}
        </div>

        <ProductList products={products} />
      </div>
      <BottomNav />
    </Layout>
  );
}


